"use client";

import { useTheme } from '@/app/providers/ThemeProvider';

const ThemeToggle = () => {
  const themeManager = useTheme();

  return (
    <button
      onClick={themeManager.toggleTheme}
      className="p-2 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600"
    >
      <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-5 w-5 text-gray-800 dark:text-gray-200"
        >
          <g stroke="none" fill="none" fillRule="evenodd">
            <g fill="currentColor" fillRule="nonzero">
              <path d="M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,20 L12,4 C16.418278,4 20,7.581722 20,12 C20,16.418278 16.418278,20 12,20 Z" />
            </g>
          </g>
        </svg>
    </button>
  );
};

export default ThemeToggle;